import qs from "qs";

// Action Types
export const LIST = "bontempo/clothingCategories/LIST";
export const LIST_SUCCESS = "bontempo/clothingCategories/LIST_SUCCESS";
export const LIST_FAIL = "bontempo/clothingCategories/LIST_FAIL";

export const DETAILS = "bontempo/clothingCategories/DETAILS";
export const DETAILS_SUCCESS = "bontempo/clothingCategories/DETAILS_SUCCESS";
export const DETAILS_FAIL = "bontempo/clothingCategories/DETAILS_FAIL";

export const SAVE = "bontempo/clothingCategories/SAVE";
export const SAVE_SUCCESS = "bontempo/clothingCategories/SAVE_SUCCESS";
export const SAVE_FAIL = "bontempo/clothingCategories/SAVE_FAIL";

export const DELETE = "bontempo/clothingCategories/DELETE";
export const DELETE_SUCCESS = "bontempo/clothingCategories/DELETE_SUCCESS";
export const DELETE_FAIL = "bontempo/clothingCategories/DELETE_FAIL";

// Reducer
const initialState = {
  data: null,
  details: null,
  loading: false,
  module: "looks/categorias",
  total: 0
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LIST:
      return { ...state, loading: true };
    case LIST_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    case LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case DETAILS:
      return { ...state, loading: true };
    case DETAILS_SUCCESS:
      let details = action.payload.data;

      if (details.combinations) {
        details.combinations = details.combinations.map(category => {
          return category.id;
        });
      }

      if (details.placements) {
        details.placements = details.placements.map(category => {
          return category.id;
        });
      }

      return {
        ...state,
        details,
        loading: false
      };
    case DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case SAVE:
      return { ...state, loading: true };
    case SAVE_SUCCESS:
    case SAVE_FAIL:
      return { ...state, loading: false };

    case DELETE:
      return { ...state, loading: true };
    case DELETE_SUCCESS:
    case DELETE_FAIL:
      return { ...state, loading: false };

    default:
      return state;
  }
}

// Action Creators
export function get(params) {
  return {
    type: LIST,
    payload: {
      request: {
        url: `/clothing-categories?${qs.stringify(params)}`
      }
    }
  };
}

export function getDetails(id) {
  return {
    type: DETAILS,
    payload: {
      request: {
        url: `/clothing-categories/${id}`
      }
    }
  };
}

export function add(data) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/clothing-categories`,
        method: "post",
        data: data
      }
    }
  };
}

export function edit(data, id) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/clothing-categories/${id}`,
        method: "put",
        data: data
      }
    }
  };
}

export function remove(id) {
  return {
    type: DELETE,
    payload: {
      request: {
        url: `/clothing-categories/${id}`,
        method: "delete"
      }
    }
  };
}
